/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:14 PM
 *
 */

import Loader from 'components/Loader/Loader';

export default Loader;
